import React from 'react';
import _ from 'lodash';
import ContentAddIcon from 'material-ui/svg-icons/content/add-circle-outline';
import ContentRemoveIcon from 'material-ui/svg-icons/content/remove-circle-outline';
import RegisterClass from './RegisterClass';
import { IconButton } from 'material-ui';

/**
 * @param {{
 *   confirmed: boolean,
 *   registerClasses: object[],
 *   changeField: Function,
 *   getError: Function,
 *   clearError: Function,
 *   modifiedFields?: string[],
 *   underStyle?: import('react').CSSProperties,
 * }} props
 */
function RegisterClasses({
    confirmed, registerClasses, modifiedFields, underStyle, changeField,
    getError, clearError,
}) {
    const handleAdd = () => {
        changeField({
            field: 'registerClasses',
            value: [...registerClasses, { _id: '', name: '' }]
        });
    };
    const handleRemove = (index) => {
        const value = registerClasses.slice();
        value.splice(index, 1);
        changeField({
            field: 'registerClasses',
            value,
        });
    };
    const handleChange = (index, changes) => {
        if (!Array.isArray(changes)) {
            changes = [changes];
        }
        changeField(changes.map(({ field, value }) => ({
            field: field === 'registerClass'
                ? `registerClasses.${index}`
                : `registerClasses.${index}.${field.replace('registerClass.', '')}`,
            value,
        })));
    };
    return (
        <React.Fragment>
            {registerClasses.map((registerClass, index) => (
                <div className='row' key={`${registerClass._id}-${index}`}>
                    <div className='col-xs-6'>
                        <RegisterClass
                            registerClass={registerClass}
                            changeField={change => handleChange(index, change)}
                            confirmed={!confirmed}
                            getError={index === 0 ? () => getError('registerClasses') : () => ''}
                            underStyle={modifiedFields && modifiedFields.includes(`registerClasses.${index}.name`) ? underStyle : null}
                            clearError={clearError}
                        />
                    </div>
                    <div className='col-xs-2'>
                        {index === 0 && (
                            <IconButton
                                onClick={handleAdd}
                                style={{ margin: '28px 0 0 8px' }}
                            >
                                <ContentAddIcon color='green' />
                            </IconButton>
                        )}
                        {index !== 0 && (
                            <IconButton
                                onClick={() => handleRemove(index)}
                                style={{ margin: '28px 0 0 8px' }}
                            >
                                <ContentRemoveIcon color='red' />
                            </IconButton>
                        )}
                    </div>
                </div>
            ))}
        </React.Fragment>
    );
}

export default RegisterClasses;



// WEBPACK FOOTER //
// ./app/components/Vessels/Single/Rows/RegisterClasses.jsx